module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Tipos de Certificados")]), _vm._v(" "), _c('div', {
    staticClass: "texto"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n\t\t\tCertificados de política A1 são aqueles em que a chave privada é gerada em software, e fica armazenada\n\t\t\tem um arquivo ou programa de computador. É possível e recomendável realizar cópia de segurança do certificado.\n\t\t\tA validade máxima do certificado A1 é de um ano.\n\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "name": "precos"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\tApresentamos a seguir os diferentes tipos de certificados digitais da Soluti.\n\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ccd-tipos-precos')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Política A1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "lista-downloads"
  }, [_c('li', {
    staticClass: "prod"
  }, [_vm._v("Preços de Referência")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61f328b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tipos.vue
// module id = 103
// module chunks = 0